// A browser-made id for one request, so a retry of the same request is
// recognized by the server (chat turn ids, idempotency keys).
export function newKey() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}
